module.exports = __webpack_public_path__ + "img/nucleus2.c6eab403.png";